import * as React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { WidthProps, width } from 'styled-system';
import { themeGet, FixedRatio, Text } from '@packages/ui';
import { ImageCDNProvider, ModuleCategoriesItem, publicAssetsImageSrcToCdnImageSrc } from '@packages/common';

import { MultilineText } from '../../MultilineText/MultilineText';

export type CategoriesItemProps = ModuleCategoriesItem & {
  onClick?: (item: CategoriesItemProps) => void;
  showLabel?: boolean;
  cdnProvider?: ImageCDNProvider;
};

// TODO: primaryDark for active state
export const StyledCallToAction = styled.a`
  color: ${themeGet.colors('swirl')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  user-select: none;

  &:hover,
  &:active {
    transform: scale(1.11, 1.11);
  }

  &:hover {
    text-decoration: underline;
    color: ${themeGet.colors('primary')};
  }
  &:active {
    text-decoration: none;
    color: ${themeGet.colors('primary')};
  }
`;

export const Container = styled.div<WidthProps>`
  text-align: center;
  ${width}
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  user-select: none;
  object-fit: cover;
  transition: transform 0.2s ease-out;
`;

const TextContent: any = styled(Text)`
  word-break: normal;
  text-align: center;
  max-width: 120px;
  :hover {
    text-decoration: underline;
    color: ${themeGet.colors('primary')};
  }
  :active {
    text-decoration: none;
    color: ${themeGet.colors('primaryDark')};
  }
`;

export const CategoriesItem: React.FC<CategoriesItemProps> = (props) => {
  const handleClick = () => {
    const { onClick } = props;
    if (onClick) {
      onClick(props);
    }
  };

  const { title, image, cta, showLabel, cdnProvider } = props;
  const src = publicAssetsImageSrcToCdnImageSrc(image, cdnProvider);
  const href = cta.url
    ?.replace('https://www.moebel.de', '')
    .replace('https://www.meubles.fr', '')
    .replace('https://www.meubelo.nl', '');

  return (
    <Link href={href}>
      <StyledCallToAction href={href} onClick={handleClick} data-testid="styled-cta">
        <Container width={['100px', '112px', '144px', '144px', '112px', '144px']}>
          <FixedRatio ratio={1}>
            <Image loading="lazy" src={src} alt={title} />
          </FixedRatio>
        </Container>
        {showLabel && (
          <TextContent tag="p" pt={3} pl={0} pr={0} fontWeight={'normal'} fontSize={6}>
            <MultilineText>{title}</MultilineText>
          </TextContent>
        )}
      </StyledCallToAction>
    </Link>
  );
};
